import { Component } from '@angular/core';

@Component({
  selector: 'app-landings',
  templateUrl: './landings.component.html',
  styleUrls: ['./landings.component.css']
})
export class LandingsComponent {

}
